import { render, staticRenderFns } from "./instructionAction.vue?vue&type=template&id=147089f5"
import script from "./instructionAction.vue?vue&type=script&lang=js"
export * from "./instructionAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports